export function* batched<T>(iterable: Iterable<T>, size: number) {
  let batch = [] as T[]
  for (const item of iterable) {
    batch.push(item)
    if (batch.length === size) {
      yield batch
      batch = []
    }
  }
  if (batch.length) {
    yield batch
  }
}

export async function asArray<T>(asyncGenerator: AsyncGenerator<T>) {
  const result = [] as T[]
  for await (const item of asyncGenerator) {
    result.push(item)
  }
  return result
}
